import React, { Component } from 'react';
// import { connect } from 'react-redux';

import { Form, Field, InputField, ResetOnSuccess, FormError } from '../form';

import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';

import classNames from 'classnames';

import { size, map, last } from 'lodash';

import { FormGroup, Button, Alert } from 'reactstrap';

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';
import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import pluralize from 'pluralize';

import { PixelIcon } from './pixelsIcons';
import PixelIdInstructions from './PixelIdInstructions';

import DropdownSelectAdapter from '../form/DropdownSelectAdapter';


const platforms = {
  facebook: "Facebook Pixel",
  adwords: "Google Adwords",
  twitter: "Twitter",
  pinterest: "Pinterest",
  quora: "Quora",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  snapchat: "Snapchat",
  gtm: "Google Analytics"
}



class PixelSetForm extends Component {
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, initialValues, submitValue, hideName } = this.props
    const hasId = initialValues && initialValues.id
    // dropdownOpen={!(values.pixels[index] || {}).platform_id}
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess}}
        mutators={{...arrayMutators}}
        initialValues={ {...{pixels:[{platform: 'facebook'}]}, ...(initialValues || {})} }
        render={({ submitError, handleSubmit, submitting, pristine, values, form:{reset, mutators: { push, pop }} }) => (
          
          <form onSubmit={handleSubmit} noValidate={true} name="pixel">
            {submitError && <FormError>{submitError}</FormError>}
            
            <ActivateModalTrigger />
            <AccountLimitsError />
            
            <FormGroup className={classNames({"hide": hideName})}>
              <InputField meta={{submitting}} name="name" type="text" placeholder="Name your pixels list" />
            </FormGroup>
            
            <FieldArray name="pixels">
              {({ fields }) =>
                fields.map((name, index) => (
                  <FormGroup key={name} className={classNames({"pixel-input": true, "with-remove": size(fields) > 1})}>
                    <div className="input-group">
                      <Field
                        className="input-group-prepend"
                        name={`${name}.platform`}
                        placeholder="Platform"
                        component={DropdownSelectAdapter}
                      >
                        {map(platforms, (title, platform)=>{
                          return <option value={platform} key={platform} label={<PixelIcon platform={platform} />}><PixelIcon platform={platform} />  {title}</option>
                        })}
                      </Field>
                      
                      <InputField meta={{submitting}} name={`${name}.platform_id`} type="text" placeholder="Pixel id" />
                    </div>
                    {size(fields) > 1 &&
                      <Button
                        outline
                        color="link"
                        title="Remove"
                        className="remove-button"
                        onClick={() => fields.remove(index)}>
                          <FA icon={faTrashAlt} />
                      </Button>
                    }
                  </FormGroup>
                ))}
            </FieldArray>
            
            {<PixelIdInstructions platform={(last(values.pixels || []) || {}).platform} />}
            
            <FormGroup align="right">
              <Button color="outline-dashed"
                block
                onClick={() => push('pixels', {platform:'facebook'})}>
                <FA icon={faPlus} /> add another pixel
              </Button>
            </FormGroup>
            
            { !pristine && hasId && initialValues.links_num > 0 && <Alert color="warning">Update will affect on {initialValues.links_num} {pluralize('link', initialValues.links_num)}</Alert>}
            
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                block={true}
                className="btn-wide upcase"
                disabled={submitting}>
                { submitValue || (hasId && 'Save') || 'Create' }
              </Button>
              
            </FormGroup>
            
            <ResetOnSuccess enabled={true} reset={reset} />
            
          </form>
        )}
      />
    )
  };
}
// <pre>{JSON.stringify(values, 0, 2)}</pre>

export default PixelSetForm;


// WEBPACK FOOTER //
// ./src/components/PixelSets/form.js